module.exports = __webpack_public_path__ + "static/media/icon_transit.ac4e814d.svg";